import { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { API, authHeaders, formatErr } from "./api";
import { inputCls, Field, SaveBar, TabCard } from "./fields";

const STATUSES = ["Pre-launch", "Pilot", "Live"];

export default function QuikpikTab({ content, token, onSaved, onUnauthorized }) {
  const [draft, setDraft] = useState(content.quikpik);
  const [saving, setSaving] = useState(false);
  useEffect(() => setDraft(content.quikpik), [content.quikpik]);

  const set = (k) => (e) => setDraft({ ...draft, [k]: e.target.value });

  const save = async () => {
    setSaving(true);
    try {
      const { data } = await axios.put(`${API}/content/quikpik`, draft, authHeaders(token));
      onSaved(data);
      toast.success("Saved — live on the website now.");
    } catch (err) {
      if (err.response?.status === 401) return onUnauthorized();
      toast.error(formatErr(err, "Save failed. Try again."));
    } finally {
      setSaving(false);
    }
  };

  return (
    <TabCard title="Quikpik" sub="Shown on /quikpik, the homepage Quikpik card and /work" testid="tab-quikpik">
      <div className="grid gap-5">
        <Field label="Status label">
          <select value={draft.status} onChange={set("status")} data-testid="quikpik-field-status" className={inputCls}>
            {STATUSES.map((s) => <option key={s} value={s}>{s}</option>)}
          </select>
        </Field>
        <Field label="Pilot area text"><input value={draft.area} onChange={set("area")} data-testid="quikpik-field-area" className={inputCls} /></Field>
        <Field label="Pilot offer text"><textarea rows={3} value={draft.offer} onChange={set("offer")} data-testid="quikpik-field-offer" className={`${inputCls} resize-none`} /></Field>
        <Field label="Partner WhatsApp message" hint="Pre-filled message when a cafe taps 'Partner with Quikpik'">
          <input value={draft.wa_message} onChange={set("wa_message")} data-testid="quikpik-field-wa" className={inputCls} />
        </Field>
      </div>
      <SaveBar onSave={save} saving={saving} lastSaved={content.saved_at?.quikpik} testid="quikpik-save" />
    </TabCard>
  );
}
